<template>
    <ol class="mx-auto">
        <li v-for="asset in trendingAssets" class="mb-10px">
            <img :src="asset.thumb" class="valign-middle mr-10px"/>
            <span class="valign-middle">{{ asset.name }} ({{ asset.symbol }}) - marketcap rank: {{ asset.market_cap_rank }}</span>
        </li>
    </ol>
</template>

<script>
import { getTrendingCoins } from '@/api/coingecko'

export default {
    data(){
        return{
            trendingAssets: [],
        }
    },
    async created(){
        this.trendingAssets = (await getTrendingCoins()).map(x => x.item)
    }
}
</script>